import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-consultant-detail.tsx
var LazyConsultantDetail = lazy(() => import("./consultant-detail-BHK9tsuH.js").then((n) => n.n).then((module) => ({ default: module.ConsultantDetail })));
function ConsultantDetail({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultant-detail" }),
		children: /* @__PURE__ */ jsx(LazyConsultantDetail, { ...props })
	});
}
function ConsultantDetailContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultant-detail" }),
		children: /* @__PURE__ */ jsx(LazyConsultantDetail, { ...props })
	});
}
var useConsultantDetailContent = () => {
	return useMemo(() => ({ consultantDetail: { component: ConsultantDetailContent } }), []);
};
//#endregion
export { ConsultantDetail, useConsultantDetailContent };
